<template>
  <div class="row">
    <div class="col-lg-12 col-md-12">
      <card class="shadow-lg">
        <div class="row content-add-btn">
          <button class="btn btn-secondary" @click="$router.go(-1)">
            <em class="fa fa-chevron-left"></em>
            {{ $t('common_words.exit') }}
          </button>
        </div>
        <hr />
        <form-wizard-layout
          ref="formWizard"
          @showHideLoading="showHideLoading"
          @on-validated="onStepValidated"
          @on-complete="storeUpdateRangeColors"
          :tabsContent="tabsContent"
          v-if="this.isCreate() || this.isUpdate()"
        >
          <template slot="dataConfirm">
            <step-confirm :infoData="model" ref="stepConfirm" />
          </template>
        </form-wizard-layout>
        <div v-else>
          <br />
          <h5 class="text-muted text-center">
            {{ $t('common_words.no_permissions_operations') }}
          </h5>
        </div>
      </card>
    </div>
  </div>
</template>
<script>
import { Axios } from 'src/class/Axios.js';
import { resetObjectProperties } from 'src/util/Util.js';
import FirstStep from 'src/views/Pages/Dashboard/RangeColor/steps/FirstStep.vue';
import FormWizard from 'src/components/Layouts/FormWizard.vue';
import i18n from 'src/i18n';
import MixinAlert from 'src/mixins/mixin-alert';
import MixinLoading from 'src/mixins/mixin-loading';
import MixinMenu from 'src/util/mixinMenu';
import MixinPermissions from 'src/util/mixinPermissions';
import SecondStep from 'src/views/Pages/Dashboard/RangeColor/steps/SecondStep.vue';
import StepConfirm from 'src/views/Pages/Dashboard/RangeColor/steps/StepConfirm.vue';
import SweetAlert from 'src/class/Alerts';
export default {
  components: {
    [FormWizard.name]: FormWizard,
    FirstStep,
    SecondStep,
    StepConfirm,
  },
  data() {
    return {
      model: {},
    };
  },
  mixins: [MixinPermissions, MixinMenu, MixinLoading, MixinAlert],
  computed: {
    tabsContent() {
      return [
        {
          title: i18n.t('common_words.color_range'),
          reference: 'firstStep',
          component: FirstStep,
        },
        {
          title: i18n.t('common_words.color_range_details'),
          reference: 'secondStep',
          component: SecondStep,
        },
      ];
    },
  },
  methods: {
    cleanAllSteps() {
      this.$refs.formWizard.$refs.firstStep[0].model = {
        ...this.$refs.formWizard.$refs.firstStep[0].initialModel,
      };
      this.$refs.formWizard.$refs.firstStep[0].$refs.selectBusiness.model = {
        associations_ids: [],
        businesses_ids: [],
        names: [],
      };
      this.$refs.formWizard.$refs.firstStep[0].modules_id = [];
      this.$refs.formWizard.$refs.secondStep[0].model = {
        ...resetObjectProperties({
          ...this.$refs.formWizard.$refs.secondStep[0].model,
        }),
        totalDetail: 1,
      };
      this.model = {
        ...resetObjectProperties(this.model),
      };
    },
    validateStep(ref) {
      return this.$refs[ref].validate();
    },
    onStepValidated(dataModel) {
      this.model = { ...this.model, ...dataModel };
    },
    alertResponse(response) {
      SweetAlert.continue(
        response.data.message ? response.data.message : response.errors
      ).then((result) => {
        if (result.value) {
          try {
            this.$refs.formWizard.$refs.wizard.reset();
          } catch (error) {}
          this.cleanAllSteps();
          sessionStorage.removeItem('editForm');
        } else if (result.dismiss) {
          this.$router.push('/rangecolorheaders');
        }

        return result;
      });
    },
    storeUpdateRangeColors() {
      this.showHideLoading(true);
      this.model.route = 'rangecolorheaders';
      if (sessionStorage.getItem('editForm') && this.isUpdate()) {
        if (this.isUpdate()) {
          this.model.id = JSON.parse(sessionStorage.getItem('editForm')).id;
          Axios.updateMaster(this.model)
            .then((response) => {
              this.showHideLoading();
              this.alertResponse(response);
            })
            .catch((error) => this.showMessageErrors(error));
        } else {
          this.showMessageAccess();
          this.showHideLoading();
        }
      } else {
        if (this.isCreate()) {
          Axios.saveMaster(this.model)
            .then((response) => {
              this.showHideLoading();
              this.alertResponse(response);
            })
            .catch((error) => this.showMessageErrors(error));
        } else {
          this.showMessageAccess();
          this.showHideLoading();
        }
      }
    },
  },
  mounted() {
    this.selectedItemOnMenu('rangecolorheaders');
  },
  beforeDestroy() {
    sessionStorage.removeItem('editForm');
    sessionStorage.removeItem('tableCode');
    this.deselectedItemOnMenu('rangecolorheaders');
  },
};
</script>
